// @flow
import * as React from 'react';
import CopyableTestCardNumber from './CopyableTestCardNumber';
import IntegrationCheckerScenario from './IntegrationCheckerScenario';
import type {IntegrationCheckersDataIntegrationCheckerScenarioResult} from '../../generatedTypes';

type Props = {
  results: Array<IntegrationCheckersDataIntegrationCheckerScenarioResult>,
  dashboardUrl: string,
};

export const getResult = (
  type: string,
  results: Array<IntegrationCheckersDataIntegrationCheckerScenarioResult>,
) => {
  const filteredResult = results.find((result) => result.type === type);

  return filteredResult || null;
};

const AcceptACardPaymentScenarios = (props: Props) => {
  const {results, dashboardUrl} = props;
  return (
    <React.Fragment>
      <IntegrationCheckerScenario
        dashboardUrl={dashboardUrl}
        title="Your integration handles payments that don’t require authentication"
        testCardNumber={
          <CopyableTestCardNumber cardNumber="4242424242424242" />
        }
        result={getResult('accept_a_payment_payment_succeeds', results)}
      />
      <IntegrationCheckerScenario
        dashboardUrl={dashboardUrl}
        result={getResult('accept_a_payment_payment_requires_action', results)}
        title={`Your integration handles payments that require authentication ${' '}`}
        testCardNumber={
          <CopyableTestCardNumber cardNumber="4000002500003155" />
        }
      />
      <IntegrationCheckerScenario
        dashboardUrl={dashboardUrl}
        result={getResult(
          'accept_a_payment_payment_fails_insufficient_funds',
          results,
        )}
        title={
          <>
            Your integration handles card declines codes like{' '}
            <code>insufficient_funds</code>
          </>
        }
        testCardNumber={
          <CopyableTestCardNumber cardNumber="4000000000009995" />
        }
      />
    </React.Fragment>
  );
};

export default AcceptACardPaymentScenarios;
